import React from 'react';
import { Link } from 'react-router-dom';
import ServicesSection from '../components/ServicesSection';

export default function ServicesPage() {
  return (
    <div className="page-container">
      <section className="page-header section-dark">
        <div className="section-content">
          <div style={{ textAlign: 'center', maxWidth: '900px', margin: '0 auto' }}>
            <div className="section-eyebrow">Our Services</div>
            <h1 style={{ fontSize: '48px', marginBottom: '24px' }}>End-to-End Proposal Lifecycle Support</h1>
            <p style={{ fontSize: '20px', color: 'var(--text-secondary)' }}>
              From capture strategy through final submission, we provide comprehensive support tailored to your organization's capabilities and constraints.
            </p>
          </div>
        </div>
      </section>

      <ServicesSection />
      
      <section className="section section-dark">
        <div className="section-content">
          <div style={{ textAlign: 'center' }}>
            <h2 style={{ marginBottom: '24px' }}>Not Sure Which Service You Need?</h2>
            <p style={{ fontSize: '18px', color: 'var(--text-secondary)', marginBottom: '32px', maxWidth: '700px', margin: '0 auto 32px' }}>
              Schedule a free consultation to discuss your upcoming RFP and determine the best approach.
            </p>
            <Link to="/contact" className="btn-primary">Contact Us</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
